import { Select } from '@fourthwall/components';
import React from 'react';
import { FormFields } from '../../hooks/useBadgeForm/types';
export const SelectRule = ({ form, options, onChange }) => (React.createElement(Select, { options: options, label: "Requirement to earn badge", fullWidth: true, value: "", onValueChange: (value) => {
        let newRule;
        if (value === 'MemberStreak') {
            newRule = { type: 'MemberStreak', monthsFrom: 0, monthsTo: 0 };
        }
        else if (value === 'Tier') {
            newRule = { type: 'Tier', tierId: undefined };
        }
        else {
            newRule = { type: value };
        }
        form.setFieldValue(FormFields.rules, [
            ...form.values.rules.filter((rule) => rule.type !== 'EmptyRule'),
            newRule,
        ]);
        onChange?.();
    } }));
